import { BaseCopyButton } from '@/shared/components/BaseCopyButton/BaseCopyButton'
import React from 'react'

type Props = {
  text: string | undefined | null
  title?: string
  children: React.ReactNode
  color?: 'primary' | 'secondary'
  size?: 'mini' | 'base'
  className?: string
}

export const CopyBlock = ({
  text,
  title,
  children,
  color = 'primary',
  size = 'mini',
  className,
}: Props) => {
  return (
    <span
      className={`inline-flex items-center gap-2 whitespace-nowrap ${color === 'secondary' ? 'text-text-secondary' : ''} ${className ?? ''}`}
      title={title || ''}
    >
      {children}
      {text && <BaseCopyButton text={text} color={color} size={size} />}
    </span>
  )
}
